<template>
<div class="chapter">
<div class="inner_page">
<p class="block_11" style="margin-top:20%;"><span class="text_4">“We can only learn to love by loving.”</span></p>
<p class="block_7"> </p>
<p class="block_12"><span class="text_4">— Iris Murdoch</span></p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_11"><span class="text_4">“There is some soul of goodness in things evil, would men observingly distill it out.”</span></p>
<p class="block_7"> </p>
<p class="block_12"><span class="text_4">— Shakespeare</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?7a500d35